export default __webpack_public_path__ + "media/trendMicroCloudOneForGovernmentDiagram.1e094edb.png";